// Studyo Today Backend
// Package studyo.today.curriculum.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.3 with parameter "import_extension=js"
// @generated from file studyo/today/curriculum/v1/resources/user_persona.proto (package studyo.today.curriculum.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/curriculum/v1/resources/user_persona.proto.
 */
export const file_studyo_today_curriculum_v1_resources_user_persona = /*@__PURE__*/
  fileDesc("CjdzdHVkeW8vdG9kYXkvY3VycmljdWx1bS92MS9yZXNvdXJjZXMvdXNlcl9wZXJzb25hLnByb3RvEiRzdHVkeW8udG9kYXkuY3VycmljdWx1bS52MS5yZXNvdXJjZXMqeAoLVXNlclBlcnNvbmESHAoYVVNFUl9QRVJTT05BX1VOU1BFQ0lGSUVEEAASFwoTVVNFUl9QRVJTT05BX1BBUkVOVBABEhgKFFVTRVJfUEVSU09OQV9URUFDSEVSEAISGAoUVVNFUl9QRVJTT05BX1NUVURFTlQQA0IsqgIpU3R1ZHlvLlRvZGF5LkN1cnJpY3VsdW0uR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.curriculum.v1.resources.UserPersona.
 */
export const UserPersonaSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_curriculum_v1_resources_user_persona, 0);

/**
 * A persona for a user.
 *
 * @generated from enum studyo.today.curriculum.v1.resources.UserPersona
 */
export const UserPersona = /*@__PURE__*/
  tsEnum(UserPersonaSchema);

